export interface TempDataInterface {
  textFieldValues: Record<string, string>;
  selectedKeyPersonOption: { label: string; value: string } | undefined;
  selectedResponsibleOptions: { label: string; value: string }[];
  moduleInformation: Record<string, any>;
  machineList: any[];
  preassemblyImage: Record<string, any>;
}

export const tempDataRefTemplate: TempDataInterface = {
  textFieldValues: {},
  selectedKeyPersonOption: undefined,
  selectedResponsibleOptions: [],
  moduleInformation: {},
  machineList: [],
  preassemblyImage: {}
};